import { render, staticRenderFns } from "./SearchBoxIcon.vue?vue&type=template&id=1330caa8&scoped=true&"
import script from "./SearchBoxIcon.vue?vue&type=script&lang=js&"
export * from "./SearchBoxIcon.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxIcon.vue?vue&type=style&index=0&id=1330caa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330caa8",
  null
  
)

export default component.exports